const API_BASE_URL = process.env.VUE_APP_API_URL || ''

export function getApiUrl(path) {
  if (!path) return API_BASE_URL
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return API_BASE_URL ? `${API_BASE_URL}${cleanPath}` : cleanPath
}

export default API_BASE_URL
